import { snakeCase, camelCase, startCase } from 'lodash-es'

const defaultSkipKeys = [
  'id__in',
  'tags__in',
  'tags__not_in',
  'template__id',
  'template__id__in',
  'modified_at__gtr',
  'created_at__gtr',
  'end_at__lt',
  'start_at__gt',
  'account__id',
  'end_at__gt',
  'end_at__range',
  'start_at__lt',
  'start_at__range',
  'external_objects__connection_id',
  'external_objects__content_type',
  'external_objects__external_content_type',
  'external_objects__external_object_id',
  'owned_by__name__icontains',
  'template__name__icontains',
]

const defaultSkipObjectKeys = ['context', 'overrides', 'filters', 'metadata', 'style', 'hidden']

const shouldSkipObjectKey = (key: string, skipObjectKeys: string[]): boolean => {
  return skipObjectKeys.includes(key) || key.endsWith('style')
}

export const camelCaseKeys = <T>(obj: T, skipKeys = defaultSkipKeys, skipObjectKeys = defaultSkipObjectKeys): T => {
  if (Array.isArray(obj)) {
    return obj.map((v) => camelCaseKeys(v, skipKeys, skipObjectKeys)) as T
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => {
      const skip = shouldSkipObjectKey(key, skipObjectKeys)
      const newKey = skipKeys.includes(key) || skip ? key : camelCase(key)
      const value = skip ? (obj as any)[key] : camelCaseKeys((obj as any)[key], skipKeys, skipObjectKeys)
      return { ...result, [newKey]: value }
    }, {}) as T
  }

  return obj
}

export const snakeCaseKeys = <T>(obj: T, skipKeys = defaultSkipKeys, skipObjectKeys = defaultSkipObjectKeys): T => {
  if (Array.isArray(obj)) {
    return obj.map((v) => snakeCaseKeys(v, skipKeys, skipObjectKeys)) as T
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => {
      const skip = shouldSkipObjectKey(key, skipObjectKeys)
      const newKey = skipKeys.includes(key) || skip ? key : snakeCase(key)
      const value = skip ? (obj as any)[key] : snakeCaseKeys((obj as any)[key], skipKeys, skipObjectKeys)
      return { ...result, [newKey]: value }
    }, {}) as T
  }

  return obj
}

export const pascalCaseKeys = <T>(obj: T, skipKeys = defaultSkipKeys, skipObjectKeys = defaultSkipObjectKeys): T => {
  if (Array.isArray(obj)) {
    return obj.map((v) => pascalCaseKeys(v, skipKeys, skipObjectKeys)) as T
  } else if (obj != null && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => {
      const skip = shouldSkipObjectKey(key, skipObjectKeys)
      const newKey = skipKeys.includes(key) || skip ? key : titleCase(key).replace(/ /g, '')
      const value = skip ? (obj as any)[key] : pascalCaseKeys((obj as any)[key], skipKeys, skipObjectKeys)
      return { ...result, [newKey]: value }
    }, {}) as T
  }

  return obj
}

export const titleCase = (s?: string) => startCase(camelCase(s))
